<div class="flex flex-col bg-card overflow-hidden height-100p">
  <form class="form-panel">
    <div
      class="pl-3 pr-3 pt-2 pb-2 border-b flex items-center min-h-ts-panel-header"
      appAccountColorBackground
      #backgroundDirective="appAccountColorBackground"
      [colorName]="panelDef?.color"
    >
      <div class="flex items-center flex-auto" *ngIf="editMode">
        <app-form-field [fieldDef]="titleFieldDef" [model]="project" (onUpdate)="update($event)"></app-form-field>
      </div>
      <div class="flex flex-col">
        <div
          *ngIf="!editMode"
          class="font-bold text-md uppercase tracking-wider"
          [ngClass]="backgroundDirective.isContrastLight ? 'text-white' : 'text-secondary'"
        >
          {{ panelDef.title }}
        </div>
      </div>
      <div class="ml-auto flex min-height-action-buttons" *ngIf="!readonly">
        <ts-button
          [disabled]="savingChanges | async"
          type="stroked"
          color="accent"
          (click)="discardChanges()"
          *ngIf="hasPendingChanges"
          class="mr-2"
          >Discard
        </ts-button>
        <ts-button
          [loading]="savingChanges | async"
          (click)="saveChanges()"
          [debounceTime]="500"
          *ngIf="hasPendingChanges"
          >Save changes
        </ts-button>
        <button mat-icon-button type="button" *ngIf="!editMode && canEditPanelDef" [matMenuTriggerFor]="listCard09Menu">
          <mat-icon
            class="icon-size-20"
            [svgIcon]="'more_vert'"
            [ngClass]="backgroundDirective.isContrastLight ? 'text-white' : 'text-secondary'"
          ></mat-icon>
        </button>
        <mat-menu #listCard09Menu="matMenu">
          <button *ngIf="panelDef.type !== 'roles'" mat-menu-item (click)="toggleEditMode()" type="button">
            <mat-icon [svgIcon]="'edit'"></mat-icon>
            Edit Layout
          </button>
          <button mat-menu-item [matMenuTriggerFor]="toggleLabelMenu" type="button">
            <mat-icon [svgIcon]="'color_lens'"></mat-icon>
            Heading Color
          </button>
          <mat-menu class="mailbox-details-toggle-label-menu-panel" #toggleLabelMenu="matMenu">
            <div
              mat-menu-item
              class="gap-2"
              *ngFor="let color of accountColors$ | async"
              (click)="selectHeaderColor(color.name)"
            >
              <ts-color-bubble [hexColor]="color.hex_value"></ts-color-bubble>
              {{ color.label }}
            </div>
          </mat-menu>
        </mat-menu>
        <button
          class="cancel-button"
          mat-icon-button
          type="button"
          *ngIf="editMode"
          [matTooltip]="'Cancel'"
          (click)="cancelEdits()"
        >
          <mat-icon
            [svgIcon]="'cancel'"
            [ngClass]="backgroundDirective.isContrastLight ? 'text-white' : 'text-secondary'"
          ></mat-icon>
        </button>
        <button
          mat-icon-button
          type="button"
          *ngIf="editMode && (!fields || fields.length <= 0)"
          [matTooltip]="'Add Row'"
          #addContactPanelOrigin
          (click)="addRow(0)"
        >
          <mat-icon
            [svgIcon]="'add_circle'"
            [ngClass]="backgroundDirective.isContrastLight ? 'text-white' : 'text-secondary'"
          ></mat-icon>
        </button>

        <!-- Save button -->
        <button mat-icon-button *ngIf="editMode" type="submit" (click)="saveLayout()" [matTooltip]="'Save'">
          <mat-icon
            [svgIcon]="'save'"
            [ngClass]="backgroundDirective.isContrastLight ? 'text-white' : 'text-secondary'"
          ></mat-icon>
        </button>
      </div>
    </div>
    <div class="flex flex-col p-8 form-panel__body">
      <ng-container *ngIf="!editMode">
        <div
          class="flex flex-col gt-xs:flex-row"
          [class.form-panel__body__form-last-row]="lastRow"
          *ngFor="let fieldRow of fields; let lastRow = last"
        >
          <ng-container *ngFor="let fieldName of fieldRow">
            <ng-container *ngIf="lookupField(fieldName) as fieldDef">
              <app-form-field
                [class.pending-to-save]="pendingToSave(fieldDef.name)"
                [fieldDef]="fieldDef"
                [model]="project"
                (onUpdate)="update($event)"
                [data]="data"
                [readonly]="fieldDef.meta?.readonly || readonly"
              ></app-form-field>
            </ng-container>
          </ng-container>
        </div>
      </ng-container>
      <ng-container *ngIf="editMode">
        <div cdkDropListGroup>
          <div
            class="flex flex-col gt-xs:flex-row items-center edit-field-placeholder"
            *ngFor="let fieldRow of fields; let rowIndex = index; let firstRow = first; let lastRow = last"
            cdkDropList
            [cdkDropListData]="fieldRow"
            (cdkDropListDropped)="dropped($event)"
            cdkDropListOrientation="horizontal"
          >
            <div
              cdkDrag
              *ngFor="let fieldName of fieldRow; let colIndex = index; let firstCol = first; let lastCol = last"
            >
              <div class="edit-field-placeholder-content">
                <ng-container
                  dynamicFormRow
                  [elmType]="'select-field'"
                  [baseClassNames]="'flex flex-col '"
                  (allowAddNewColumn)="allowAddNewColumn($event, rowIndex)"
                >
                  <ng-container *ngIf="lookupField(fieldName) as fieldDef">
                    <mat-icon class="drag-handler" svgIcon="drag_indicator" matTooltip="Drag me" cdkDragHandle>
                    </mat-icon>
                    <select-field
                      [data]="data"
                      class="flex flex-col select-field"
                      [fieldDef]="fieldDef"
                      (update)="onFieldSelectionChange($event, rowIndex, colIndex)"
                      [model]="panelDef"
                      [rowIndex]="rowIndex"
                      [colIndex]="colIndex"
                    >
                    </select-field>
                  </ng-container>
                  <button
                    class="remove-email-field"
                    type="button"
                    *ngIf="!(firstRow && lastRow)"
                    mat-icon-button
                    (click)="removeField(rowIndex, colIndex)"
                    matTooltip="Remove"
                  >
                    <mat-icon [svgIcon]="'cancel'"></mat-icon>
                  </button>
                  <button
                    class="add-email-field"
                    type="button"
                    *ngIf="lastCol"
                    mat-icon-button
                    [disabled]="rowActionDisabled[rowIndex]"
                    (click)="addField(rowIndex, colIndex)"
                    matTooltip="Add"
                  >
                    <mat-icon [svgIcon]="'add_circle'"></mat-icon>
                  </button>
                  <button
                    class="add-email-field"
                    type="button"
                    *ngIf="lastCol"
                    mat-icon-button
                    (click)="addRow(rowIndex)"
                    matTooltip="Add"
                  >
                    <mat-icon [svgIcon]="'library_add'"></mat-icon>
                  </button>
                </ng-container>
              </div>
            </div>
          </div>
        </div>
      </ng-container>
    </div>
  </form>
</div>
